import { onBeforeUnmount, onMounted, ref } from 'vue'
import { BREAKPOINTS, type BreakpointName, mediaMax } from '../config/breakpoints'

/** Reaktives `isMax(bp)` über matchMedia, SSR-sicher. */
export function useBreakpoint(bp: BreakpointName) {
  const matches = ref(false)
  let mql: MediaQueryList | null = null
  const update = () => { matches.value = !!mql?.matches }

  onMounted(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    mql = window.matchMedia(mediaMax(bp))
    update()
    mql.addEventListener?.('change', update)
  })
  onBeforeUnmount(() => { mql?.removeEventListener?.('change', update) })

  return { matches, px: BREAKPOINTS[bp] }
}
